import { isEmpty } from "@swiggy-private/js-utils";
import { CouponCardType } from "@swiggy-private/dls-web-recipe-common-web/dist/components/CouponCard";

import { CouponTagIdentifiers, CouponTimerPayload, RibbonUIMetaData } from "@swiggy-private/core-types";
import { DOUBLE_OFFER_COUPON_TYPE } from "@core-ui/constants/Coupon";
import { COUPON_GROUP_TYPES } from "@core-ui/interfaces/Common";

export const isBestCouponGroup = (type: COUPON_GROUP_TYPES): boolean => {
    return type === COUPON_GROUP_TYPES.BEST_COUPON;
};

export const isGreatDealCouponGroup = (type: COUPON_GROUP_TYPES) => {
    return type === COUPON_GROUP_TYPES.GREAT_DEALS;
};

export const isDoubleOfferCouponGroup = (type?: string): boolean => {
    return type === DOUBLE_OFFER_COUPON_TYPE;
};

export const isPaymentOfferCouponGroup = (type: COUPON_GROUP_TYPES): boolean => {
    return type === COUPON_GROUP_TYPES.PAYMENT_OFFERS;
};

export const isAppliedCouponGroup = (type: COUPON_GROUP_TYPES): boolean => {
    return type === COUPON_GROUP_TYPES.APPLIED_OFFERS;
};

export const isRecommendedCouponGroup = (type: COUPON_GROUP_TYPES): boolean => {
    return type === COUPON_GROUP_TYPES.RECOMMENDED_OFFERS;
};

export const getTransformedHtmlString = (value?: string): string | undefined => {
    // HACK: This implementation of replacing /n with <br> is required to backward-support app side implementation
    // and should be removed once coupon listing is 100% migrated to web
    return value?.replace(/\n/g, "<br>");
};

export const isIPLSwiggySixesOfferTag = (tagIdentifiers?: CouponTagIdentifiers[]) => {
    return !isEmpty(tagIdentifiers) && tagIdentifiers?.includes(CouponTagIdentifiers.IPL_SUPER_SIX_OFFER);
};

export const isIPLSwiggySixesOfferCardWithAsset = (
    tagIdentifiers?: CouponTagIdentifiers[],
    ribbonUiMeta?: RibbonUIMetaData,
) => {
    return isIPLSwiggySixesOfferTag(tagIdentifiers) && !isEmpty(ribbonUiMeta?.asset?.icon);
};

export const generateTimerPayloadForSwiggySixAnalytics = (
    timerEnabled: boolean,
    timestampInMs?: number,
): CouponTimerPayload => {
    return {
        isTimer: timerEnabled,
        timerValue: String(timestampInMs || ""),
    };
};

export const getCouponType = (isPaymentListingCouponCard: boolean) => {
    return isPaymentListingCouponCard ? "Payment" : "Restaurant";
};

export const getCouponListingType = (isPaymentCouponCard?: boolean): CouponCardType => {
    return isPaymentCouponCard ? CouponCardType.PAYMENT_COUPON_CARD : CouponCardType.RESTAURANT_COUPON_CARD;
};
